import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import Modal from 'react-modal'
import ContactModal from './contactModal'
import ContactZoom from './contactZoom'
import ContactsList from './contactsList'
import styles from './contacts.scss'
import {loadContacts, showContactModal, hideContactModal, zoomContact, closeContact, removeContactById, setContact, fetchClientOptionsDict} from 'state/actions'
import {formatDate, generateClientDicts, generateGlobalOptionsObject} from 'lib/helpers'
import zipcodes from '../bpostSelect.json'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'

const _ = i18n('office')

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		padding: '0',
		overflow: 'visible',
	},
}
const zipCodeOptions = zipcodes.map(({zip, city}) => {
	const search = city.toLowerCase().split(/[^a-z]+/).join('|')
	return {
		value: `${zip}_${city}`,
		label: `${zip}, ${city}`,
		search: `|${zip}|${search}`,
	}
})

export const ContactNameValue = ({contact}) => {
	const {name} = contact
	if (!name) {return <span>? ?</span>}
	const fullName = name.first + ' ' + name.last
	return (
		<div>{fullName}</div>
	)
}
ContactNameValue.propTypes = {
	contact: PropTypes.object,
}

@connect(state => ({
	contacts: state.office.contacts,
	contactZoom: state.office.contactZoom,
    contactModal: state.office.contactModal,
    clientOptionsDict: state.client.clientOptionsDict,
    appLanguage: state.app.lang
}))
export default class Contacts extends React.Component {
	static propTypes = {
		contacts: React.PropTypes.array,
		contactZoom: React.PropTypes.object,
		contactModal: React.PropTypes.object,
		dispatch: React.PropTypes.func.isRequired,
		clientOptionsDict: React.PropTypes.object,
		appLanguage: React.PropTypes.string,
    }

	constructor(props) {
		super(props)

		this.onCloseModal = this.onCloseModal.bind(this)
		this.onShowContactModal = this.onShowContactModal.bind(this)
		this.onContactClicked = this.onContactClicked.bind(this)
		this.onRemoveContact = this.onRemoveContact.bind(this)
		this.onCloseContact = this.onCloseContact.bind(this)
        this.onSaveContact = this.onSaveContact.bind(this)

        this.state = {countries: [], countriesMultiLang: {}}
    }

    componentWillMount() {
        const { dispatch, clientOptionsDict } = this.props

        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            dispatch(fetchClientOptionsDict())
            .then((dictionary) => {
                this.setClientOptionsDict(dictionary)
            })
        } else {
            if (!this.state.clientDictionary) {
                this.setClientOptionsDict(clientOptionsDict)
            }
        }
    }


    /**
     * Set client options dict in to the state
     * @param {object} dictionary - contains the dictionary
     */
    setClientOptionsDict(dictionary) {
        const {appLanguage} = this.props
        let clientDict = generateClientDicts(dictionary, appLanguage)
        this.setState({clientDictionary: clientDict})
        this.setState({countries: clientDict.country})

        this.setState({countriesMultiLang: {
            nl: generateGlobalOptionsObject(dictionary.LAND, "nl"),
            fr: generateGlobalOptionsObject(dictionary.LAND, "fr"),
            en: generateGlobalOptionsObject(dictionary.LAND, "en")
        }})

    }

    /* componentWillMount() {
        const {dispatch, clientOptionsDict} = this.props

        // load client option dict from oracle
        if (!clientOptionsDict || clientOptionsDict.length < 1) {
            dispatch(fetchClientOptionsDict()).then((response) => {

                // find all belgium translation variation by oracle
                let nlBelgium = this.getBelgiumTranslationsByLang(response, "nl") || []
                let frBelgium = this.getBelgiumTranslationsByLang(response, "fr") || []
                let enBelgium = this.getBelgiumTranslationsByLang(response, "en") || []

                // filter the unnecessary redundant data
                let noDuplicates = []
                nlBelgium.concat(frBelgium).concat(enBelgium).forEach((item) => {
                    if (noDuplicates.indexOf(item) === -1) {
                        noDuplicates.push(item)
                    }
                })

                this.setState({belgiumWords: noDuplicates})
            })
        }
    } */

    /**
     *  This function collect all of the variation of spelling and writing of the Blegium word.
     * @param {object} clientOptionsDict - oracle provided translations
     * @param {string} language - nl fr en
     */
    getBelgiumTranslationsByLang (clientOptionsDict, language) {
        let clientDictionaryCountryBelgium = []

        if (!clientOptionsDict) {
            return clientDictionaryCountryBelgium
        }

        const countries = clientOptionsDict.LAND
        clientDictionaryCountryBelgium = Object.keys(countries)
            // keep all translations matched by a few correct spelled version of the name
            .filter((key) => (
                String(countries[key][language]).toLowerCase().trim() == 'België'.toLowerCase() ||
                String(countries[key][language]).toLowerCase().trim() == 'Belgique'.toLowerCase() ||
                String(countries[key][language]).toLowerCase().trim() == 'Belgium'.toLowerCase()) ||
                String(countries[key][language]).toLowerCase().trim() == 'Koninkrijk België'.toLowerCase() ||
                String(countries[key][language]).toLowerCase().trim() == 'Royaume de Belgique'.toLowerCase() ||
                String(countries[key][language]).toLowerCase().trim() == 'Kingdom of Belgium'.toLowerCase()
            )
            .map((key) => (Object.keys(countries[key]).map((langKey) => (countries[key][langKey]))))

        // initial possible variations inserted to the white list.
        let translations = ['belgie', 'belgium', 'koninkrijk belgie', 'koninkrijk belgië', 'royaume de belgique', 'kingdom of belgium']

        // reduce the array
        if (clientDictionaryCountryBelgium) {
            clientDictionaryCountryBelgium.forEach((oneArray)=>{
                if (oneArray) {
                    oneArray.forEach((oneTrans)=>{
                        // use lowercase words rto compare
                        translations.push(String(oneTrans).toLowerCase())
                    })
                }
            })
        }

        return translations
    }

    componentDidMount() {
		const {dispatch} = this.props

		// TODO this should be part of app state so URL can have contact
		dispatch(closeContact())
		this.refresh()
	}

	refresh() {
		const {dispatch} = this.props

		dispatch(loadContacts())
	}
	onCloseModal() {
		const {dispatch} = this.props

		dispatch(hideContactModal())
	}
	onShowContactModal(id) {
		const {dispatch} = this.props

		dispatch(showContactModal(id))
	}
	onContactClicked(id) {
		const {dispatch} = this.props

		dispatch(zoomContact(id))
	}
	onSaveContact(data) {
		const {dispatch, contactModal} = this.props

		if (contactModal.contactId) {data._id = contactModal.contactId}

		const formattedData = {}

		for (const value in data) {
			if (data[value] === undefined) {
				formattedData[value] = ''
			} else {
				formattedData[value] = data[value]
			}
		}

		formattedData.name = {first: formattedData.firstName, last: formattedData.lastName}
        formattedData.birthday = formattedData.birthday.replace(/\//g, '-')

        formattedData.zipCity = formattedData.zipCity.split(/[_,](.+)/)

        if (formattedData.zipCity && formattedData.zipCity.length > 1) {
            formattedData.zip = formattedData.zipCity[0]
            formattedData.city = formattedData.zipCity[1]
        } else {
            formattedData.zip = ''
            formattedData.city = formattedData.zipCity && formattedData.zipCity.join("") || ''
        }

		delete formattedData.zipCity
		delete formattedData.firstName
		delete formattedData.lastName

		this.initialized = false
		dispatch(setContact(formattedData))
		this.onCloseModal()
	}
	onRemoveContact(data) {
		const {dispatch} = this.props

		const r = confirm(_('delConf'))
		if (r === true) {
			data._deleted = true
			dispatch(removeContactById(data._id))
			dispatch(closeContact())
		}
	}
	onCloseContact() {
		const {dispatch} = this.props

		dispatch(closeContact())
    }

    /**
     * This function try to find the country name in translations. In the database from some reason not stored as an ID,
     * so mut be done this complicated method to select the saved value from a list.
     * @param {*} countryNameLabel
     */
    getTheCountryId(countryNameLabel) {
        let {countries, countriesMultiLang} = this.state
        let resultId = (countries && nesProp.get(countries.filter((oneCountry)=>
                    (String(oneCountry.label).trim().toLowerCase() == String(countryNameLabel).trim().toLowerCase())), "0.value")) || 0

        if (!resultId) {
            resultId = (countriesMultiLang.nl && nesProp.get(countriesMultiLang.nl.filter((oneCountry)=>
                (String(oneCountry.label).trim().toLowerCase() == String(countryNameLabel).trim().toLowerCase())), "0.value")) || 0
        }

        if (!resultId) {
            resultId = (countriesMultiLang.fr && nesProp.get(countriesMultiLang.fr.filter((oneCountry)=>
                (String(oneCountry.label).trim().toLowerCase() == String(countryNameLabel).trim().toLowerCase())), "0.value")) || 0
        }

        if (!resultId) {
            resultId = (countriesMultiLang.en && nesProp.get(countriesMultiLang.en.filter((oneCountry)=>
                (String(oneCountry.label).trim().toLowerCase() == String(countryNameLabel).trim().toLowerCase())), "0.value")) || 0
        }

        return resultId
    }

	render() {
        const {contacts, contactZoom, contactModal} = this.props
        let {countries} = this.state
		let contact = {}
		let initialValues = {}

		if (!contacts) {return false}

		if (contactZoom && contactZoom.visible) {
			contact = contacts.filter(item => (item._id === contactZoom.contactId))[0]

			if (contactModal && contactModal.visible) {
				const [yyyy, mm, dd] = contact.birthday.split("-")
				const birthday = `${dd}/${mm}/${yyyy}`
				const zipCity = `${contact.zip && contact.zip+", " || ""}${contact.city || ""}`
				const zipCityUnderscore = `${contact.zip && contact.zip+"_" || ""}${contact.city || ""}`
                const name = contact.name || {}

                let zipCityPrepare = ''

                if (zipCodeOptions) {
                    // find the free typed value if is set in the dropdown
                    let isThereAnyMatch = zipCodeOptions.filter((item)=>{
                        return (String(item.label).indexOf(contact.zip) !== -1 || String(item.value).indexOf(contact.zip) !== -1) ||
                        (String(item.label).indexOf(contact.city) !== -1 || String(item.value).indexOf(contact.city) !== -1)
                    })

                    if (isThereAnyMatch.length > 0) {
                        zipCityPrepare = isThereAnyMatch[0].value
                    }
                }

                let countryNameLabel = nesProp.get(contact, "country") || ''
                let selectedCountryId = this.getTheCountryId(countryNameLabel)

				initialValues = {
					firstName: name.first || "",
					lastName: name.last || "",
					birthday: formatDate(birthday, 'us'),
					email: contact.email || "",
					street: contact.street || "",
					houseNum: contact.houseNum || "",
					houseNumExt: contact.houseNumExt || "",
					zipCity,
					zipCitySelected: zipCityPrepare,
					zipTyped: contact.zip,
					cityTyped: contact.city,
					mobile: contact.mobile || "",
					phone: contact.phone || "",
					country: selectedCountryId || "",
					language: contact.language || "",
				}
			}
		}

		return (
			<div className={styles.contactsTable}>
				{(!contactZoom || !contactZoom.visible)
					?
						<ContactsList
							contacts={contacts}
							onShowContactModal={this.onShowContactModal}
							onContactClicked={this.onContactClicked}
						/>
					:
							<ContactZoom
								contact={contact}
								onShowContactModal={this.onShowContactModal}
								onRemoveContact={this.onRemoveContact}
								onCloseContact={this.onCloseContact}
							/>
				}
				{contactModal.visible &&
					<Modal
						isOpen
						onRequestClose={this.onCloseModal}
						style={customStyles}
						className={styles.modal}
					>
						<ContactModal
							initialValues={initialValues}
							onCloseModal={this.onCloseModal}
                            onSaveContact={this.onSaveContact}
                            countries={countries}
                            zipCodeOptions={zipCodeOptions}
						/>
					</Modal>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/contacts.jsx